import { useEffect, useState } from 'react';

// src: https://usehooks.com/useWindowSize/
export function useWindowSize() {
  // Note: This will need to be adjusted if we ever start supporting server-side rendering.

  const [windowSize, setWindowSize] = useState(() => ({
    width: window.innerWidth,
    height: window.innerHeight,
  }));

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
